import React from 'react';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';

export default function HomePage() {
  return (
    <div className="page-shell min-h-screen">
      <Header />
      <main className="pb-6">
        <Hero />
        <TrustBar className="pt-0" />
        <Features className="pt-0" />
      </main>
      <Footer />
    </div>
  );
}
